import React, { ReactNode } from "react";
import { SectionWrap, StyledSectionTitle, TitleWrap, Wrap } from "./elements";

interface Props {
  title: string;
  children: ReactNode;
}

export const Section: React.FC<Props> = React.memo(({ title, children }) => {
  return (
    <SectionWrap>
      <Wrap>
        <TitleWrap>
          <StyledSectionTitle>{title}</StyledSectionTitle>
        </TitleWrap>
        {children}
      </Wrap>
    </SectionWrap>
  );
});

Section.displayName = "Section";
